import { H5 } from 'UIComponents/elements/headings';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIPanelSection from 'UIComponents/panel/UIPanelSection';
import UIButton from 'UIComponents/button/UIButton';
import UIIcon from 'UIComponents/icon/UIIcon';
import ListSegmentationFilters from 'automation-ui-enrollment/components/common/ListSegmentationFilters';
import FormattedMessageWithObjectTypeName from 'automation-ui-i18n/FormattedMessageWithObjectTypeName';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const EnrollExistingCustom = ({
  flow,
  mode,
  openFiltersPanel,
  customFilters
}) => {
  return /*#__PURE__*/_jsx(UIPanelSection, {
    className: "m-top-10 p-top-0",
    children: /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(H5, {
        className: "m-bottom-2",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "automation-ui-enrollment.redesign.enrollExistingPanel.enrollCustom.selected.title"
        })
      }), mode === 'EXISTING' ? /*#__PURE__*/_jsx(FormattedMessageWithObjectTypeName, {
        baseLangKey: "automation-ui-enrollment.redesign.enrollExistingPanel.enrollCustom.selected.informationExisting_cob",
        objectTypeId: flow.objectTypeId
      }) : /*#__PURE__*/_jsx(FormattedMessageWithObjectTypeName, {
        baseLangKey: "automation-ui-enrollment.redesign.enrollExistingPanel.enrollCustom.selected.information_cob",
        objectTypeId: flow.objectTypeId
      }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs(View, {
        marginBlockStart: "600",
        as: "div",
        children: [/*#__PURE__*/_jsx(UIButton, {
          use: "tertiary",
          size: "small",
          onClick: openFiltersPanel,
          children: customFilters ? /*#__PURE__*/_jsx(FormattedMessage, {
            message: "automation-ui-enrollment.redesign.enrollExistingPanel.enrollCustom.selected.editFilters"
          }) : /*#__PURE__*/_jsxs(_Fragment, {
            children: [/*#__PURE__*/_jsx(UIIcon, {
              name: "add"
            }), /*#__PURE__*/_jsx(FormattedMessage, {
              message: "automation-ui-enrollment.redesign.enrollExistingPanel.enrollCustom.selected.addFilters"
            })]
          })
        }), customFilters && /*#__PURE__*/_jsx(View, {
          marginInlineEnd: "800",
          marginBlockStart: "400",
          as: "div",
          children: /*#__PURE__*/_jsx(ListSegmentationFilters, {
            objectTypeId: flow.objectTypeId,
            value: customFilters,
            readOnly: true
          })
        })]
      })]
    })
  });
};
export default EnrollExistingCustom;